import {
  DynamicFieldKey_Enum,
  TemplateType_Slug,
} from '@weave/schema-gen-ts/dist/schemas/messaging/templator/v2/model.pb';
import { RelatedType } from '@weave/schema-gen-ts/dist/schemas/sms/shared/v1/enums.pb';
import { formatDynamicFieldKey } from '@frontend/string';
import { ManualTemplateTypesWithStaticTemplate } from './types';

export const STATIC_TEMPLATE_ID = 'static-template';

export const STATIC_TEMPLATES = {
  [TemplateType_Slug.MANUAL_FORMS_MESSAGE]: `Hi ${formatDynamicFieldKey(
    DynamicFieldKey_Enum.FIRST_NAME
  )},\nWe are looking forward to your upcoming visit. Please fill out this form at your earliest convenience:\n${formatDynamicFieldKey(
    DynamicFieldKey_Enum.FORMS_LINK
  )}\nThank you,\n${formatDynamicFieldKey(DynamicFieldKey_Enum.BUSINESS_GROUP_NAME)}`,
  [TemplateType_Slug.MANUAL_PAYMENT_REQUEST]: `Hi, ${formatDynamicFieldKey(
    DynamicFieldKey_Enum.FIRST_NAME
  )} this is ${formatDynamicFieldKey(
    DynamicFieldKey_Enum.BUSINESS_GROUP_NAME
  )}. You have a balance due. Please use this secure link to pay ${formatDynamicFieldKey(
    DynamicFieldKey_Enum.TEXT_TO_PAY_LINK
  )}`,
  [TemplateType_Slug.MANUAL_REVIEW_REQUEST]: `Hi ${formatDynamicFieldKey(
    DynamicFieldKey_Enum.FIRST_NAME
  )}, thank you for visiting ${formatDynamicFieldKey(
    DynamicFieldKey_Enum.BUSINESS_GROUP_NAME
  )}! Please let us know how we did by clicking the link below.\n${formatDynamicFieldKey(
    DynamicFieldKey_Enum.REVIEW_REQUEST_LINK
  )}`,
  [TemplateType_Slug.MANUAL_REVIEW_REQUEST_PET]: `Hi ${formatDynamicFieldKey(
    DynamicFieldKey_Enum.FIRST_NAME
  )}, thank you for visiting ${formatDynamicFieldKey(
    DynamicFieldKey_Enum.BUSINESS_GROUP_NAME
  )}! Please let us know how we did by clicking the link below.\n${formatDynamicFieldKey(
    DynamicFieldKey_Enum.REVIEW_REQUEST_LINK
  )}`,
  [TemplateType_Slug.MANUAL_APPOINTMENT_REMINDER]: `Hello ${formatDynamicFieldKey(
    DynamicFieldKey_Enum.FIRST_NAME
  )}, this is ${formatDynamicFieldKey(
    DynamicFieldKey_Enum.BUSINESS_GROUP_NAME
  )}. We wanted to remind you of your upcoming appointment on ${formatDynamicFieldKey(
    DynamicFieldKey_Enum.DATE_FORMAL
  )} at ${formatDynamicFieldKey(DynamicFieldKey_Enum.TIME)}. Text us to confirm. Thank you!`,
  [TemplateType_Slug.MANUAL_APPOINTMENT_REMINDER_PET]: `Hello ${formatDynamicFieldKey(
    DynamicFieldKey_Enum.FIRST_NAME
  )}, this is ${formatDynamicFieldKey(
    DynamicFieldKey_Enum.BUSINESS_GROUP_NAME
  )}. We wanted to remind you of your appointment for ${formatDynamicFieldKey(
    DynamicFieldKey_Enum.PET_NAME
  )} on ${formatDynamicFieldKey(DynamicFieldKey_Enum.DATE_FORMAL)} at ${formatDynamicFieldKey(
    DynamicFieldKey_Enum.TIME
  )}. Text us to confirm. Thank you!`,
  [TemplateType_Slug.MANUAL_SCHEDULE_QUICK_FILL]: `Hello, ${formatDynamicFieldKey(
    DynamicFieldKey_Enum.FIRST_NAME
  )}, this is ${formatDynamicFieldKey(
    DynamicFieldKey_Enum.BUSINESS_GROUP_NAME
  )}. We have last minute opening for ${formatDynamicFieldKey(
    DynamicFieldKey_Enum.DATETIME_FORMAL
  )}\n\nReply to schedule an appointment.`,
  [TemplateType_Slug.MANUAL_CARE_CREDIT_COLLECT]: `Hi ${formatDynamicFieldKey(
    DynamicFieldKey_Enum.FIRST_NAME
  )}, this is ${formatDynamicFieldKey(
    DynamicFieldKey_Enum.BUSINESS_GROUP_NAME
  )}. You have a balance due. Please use this secure CareCredit link to pay: ${formatDynamicFieldKey(
    DynamicFieldKey_Enum.PATIENT_CARE_CREDIT_URL
  )}.`,
  [TemplateType_Slug.MANUAL_CARE_CREDIT_PREAPPROVED]: `Hi ${formatDynamicFieldKey(
    DynamicFieldKey_Enum.FIRST_NAME
  )}, this is ${formatDynamicFieldKey(
    DynamicFieldKey_Enum.BUSINESS_GROUP_NAME
  )}. You have a balance due.\n\nCongratulations, you were preapproved for a CareCredit credit card. Please use this personalized link to accept your offer and complete payment: ${formatDynamicFieldKey(
    DynamicFieldKey_Enum.PATIENT_CARE_CREDIT_URL
  )}`,
  [TemplateType_Slug.MANUAL_CARE_CREDIT_APPLICATION]: `Hi ${formatDynamicFieldKey(
    DynamicFieldKey_Enum.FIRST_NAME
  )}, this is ${formatDynamicFieldKey(
    DynamicFieldKey_Enum.BUSINESS_GROUP_NAME
  )}. Please use this secure CareCredit link you requested to complete your application for a CareCredit credit card: ${formatDynamicFieldKey(
    DynamicFieldKey_Enum.PATIENT_CARE_CREDIT_URL
  )}.`,
} satisfies Record<ManualTemplateTypesWithStaticTemplate, string>;

export const TEMPLATE_TYPE_LINK_MAP: Record<
  ManualTemplateTypesWithStaticTemplate,
  { dynamicField?: DynamicFieldKey_Enum; relatedType: RelatedType }
> = {
  [TemplateType_Slug.MANUAL_FORMS_MESSAGE]: {
    dynamicField: DynamicFieldKey_Enum.FORMS_LINK,
    relatedType: RelatedType.RELATED_TYPE_FORM,
  },
  [TemplateType_Slug.MANUAL_PAYMENT_REQUEST]: {
    dynamicField: DynamicFieldKey_Enum.TEXT_TO_PAY_LINK,
    relatedType: RelatedType.RELATED_TYPE_INVOICE,
  },
  [TemplateType_Slug.MANUAL_REVIEW_REQUEST]: {
    dynamicField: DynamicFieldKey_Enum.REVIEW_REQUEST_LINK,
    relatedType: RelatedType.RELATED_TYPE_REVIEW,
  },
  [TemplateType_Slug.MANUAL_REVIEW_REQUEST_PET]: {
    dynamicField: DynamicFieldKey_Enum.REVIEW_REQUEST_LINK,
    relatedType: RelatedType.RELATED_TYPE_REVIEW,
  },
  [TemplateType_Slug.MANUAL_APPOINTMENT_REMINDER]: {
    relatedType: RelatedType.RELATED_TYPE_APPOINTMENT,
  },
  [TemplateType_Slug.MANUAL_APPOINTMENT_REMINDER_PET]: {
    relatedType: RelatedType.RELATED_TYPE_APPOINTMENT,
  },
  [TemplateType_Slug.MANUAL_SCHEDULE_QUICK_FILL]: {
    relatedType: RelatedType.RELATED_TYPE_APPOINTMENT,
  },
  [TemplateType_Slug.MANUAL_CARE_CREDIT_COLLECT]: {
    relatedType: RelatedType.RELATED_TYPE_INVOICE,
    dynamicField: DynamicFieldKey_Enum.PATIENT_CARE_CREDIT_URL,
  },
  [TemplateType_Slug.MANUAL_CARE_CREDIT_PREAPPROVED]: {
    relatedType: RelatedType.RELATED_TYPE_INVOICE,
    dynamicField: DynamicFieldKey_Enum.PATIENT_CARE_CREDIT_URL,
  },
  [TemplateType_Slug.MANUAL_CARE_CREDIT_APPLICATION]: {
    relatedType: RelatedType.RELATED_TYPE_INVOICE,
    dynamicField: DynamicFieldKey_Enum.PATIENT_CARE_CREDIT_URL,
  },
};

export const TemplateTypesWithProgressiveFlows = [
  TemplateType_Slug.MANUAL_FORMS_MESSAGE,
  TemplateType_Slug.MANUAL_APPOINTMENT_REMINDER,
  TemplateType_Slug.MANUAL_PAYMENT_REQUEST,
];

export const ReviewTemplateTypes = [
  TemplateType_Slug.MANUAL_REVIEW_REQUEST,
  TemplateType_Slug.MANUAL_REVIEW_REQUEST_PET,
];
